<template>
  <div class="login_container bg_login">
    <!-- <cube-scroll
       ref="scroll"
       :data="items"
       :options="options"
       class="page_scroll"> -->
    <div class="login_imgLogo"><img src="../assets/images/j-i2.png" alt=""></div>
    <!-- <form action=""> -->
    <div class="login_password" v-show="!isInfo">
      <!-- @blur= "getIsUsername" @blur= "getIsPassword" @blur="getIsPhone" @blur="getIsqrCode"-->
      <input type="text" id="login_user" v-model="login_userphone" placeholder="请输入手机号">
      <input type="password" id="login_password" v-model="login_password" placeholder="请输入密码">
    </div>
    <div class="login_yzm login_password" v-show="isInfo">
      <input type="text" v-model="phone" id="phone" placeholder="请输入手机号">
      <div class="login_yzm">
        <input type="text" v-model="qrcode" placeholder="请输入验证码">
        <button @click="buttonStatus" :disabled='disableds' ref="buttonStatus">{{ btncontent }}</button>
      </div>
    </div>
    <p class="login_p">
      <router-link to="/register">
        <span class="register">注册</span>
      </router-link>
      <!--          <span class="login_type" @click="infoLogin" >{{btnText}}</span>-->
    </p>
    <!-- <div class="login_info">
      <input type="text" placeholder="请输入用户名">
      <input type="text" placeholder="请输入密码">
    </div> -->
    <button class="login_submit" :disabled='disableds2' @click="login_submit">登录</button>
    <!-- </form> -->
    <!-- </cube-scroll> -->
  </div>
</template>
<script>
import validate from '../lib/js/validata'
import validata from '../lib/js/validata'
import axios from 'axios'


export default {
  data() {
    return {
      phone: '',
      qrcode: '',
      login_userphone: '',
      login_password: '',
      btncontent: '获取验证码',
      disableds: false,
      disableds2: false,
      isInfo: true,
      btnText: '短信验证码登录',
      userInfo: {},
      appid: '',
      items: [],
      options: {},
      addcode: '',
      oldUrl: ''
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.oldUrl = from.name
    })
  },
  mounted() {
    this.$nextTick(() => {
      console.log('oldUrl:', this.oldUrl)
      if(this.oldUrl===null){
        console.log('等null')
      }else{
        console.log('不等null')
      }
    })
  },

  created() {
    this.addcode = this.GetQueryString('code')
    console.log(this.addcode)

  },
  methods: {

    GetQueryString(name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
      var r = window.location.search.substr(1).match(reg)
      if (r != null) return unescape(r[2])
      return null
    },

    getIsUsername() {
      let usernames = validate.isUsername(this.login_userphone)
      if (!usernames.UsernameStatus) {
        this.login_username = ''
      }
    },
    // getIsPhone () {
    //   let phones = validate.isPhone(this.phone);
    //   // console.log(phones)
    // },
    // getIsPassword () {
    //   let passwords = validate.isPassword(this.login_password)
    // },
    // getIsqrCode () {
    //   let qrcodes = validate.isqrCode(this.qrcode)
    //   // console.log(qrcodes)
    // },
    // 获取验证码
    buttonStatus() {
      let phonenumber = validate.isPhone(this.phone)
      if (!phonenumber.phoneStatus) {
        // console.log('请输入合法手机号');
        return
      }
      this.$createDialog({
        type: 'alert',
        content: '验证码已发送，请注意查收',
      }).show()
      let countdown = 60
      this.setTime(countdown)
      this.$http.api.phoneInfo({
        phone: this.phone
      }).then(result => {
        // console.log(result)
      })
    },
    setTime(countdown) {
      var _this = this
      if (countdown == 0) {
        this.disableds = false
        this.btncontent = '获取验证码'
        countdown = 60
        return
      } else {
        this.disableds = true
        this.btncontent = '重新发送(' + countdown + ')'
        countdown--
      }
      setTimeout(function () {
        _this.setTime(countdown)
      }, 1000)
    },
    login_submit() {

      let _this = this

      // window.scrollTo(0,0)
      // window.scrollTo(0, document.documentElement.clientHeight);
      // let isLogin = validata.isLogin()


      if (!this.isInfo) {
        if (!validate.isPhone(this.login_userphone).phoneStatus) {
          return
        } else if (!validate.isPassword(this.login_password).passwordStatus) {
          return
        }
      } else {
        if (!validate.isPhone(this.phone).phoneStatus) {
          return
        } else if (!validate.isqrCode(this.qrcode).qrCodeStatus) {
          return
        }
      }


      // isLogin.isall &&
      if (!this.isInfo) {

        this.$http.api.login({
          input: this.login_userphone,
          password: this.login_password
        }).then(result => {
          // 处理登录成功后逻辑
          // console.log(result);

          _this.userInfo = result
          localStorage.setItem('user_id', result.user_id ? result.user_id : '')
          localStorage.setItem('name', result.name ? result.name : '')
          localStorage.setItem('phone', result.phone ? result.phone : '')
          localStorage.setItem('role_id', result.role_id ? result.role_id : '')
          localStorage.setItem('role', result.role ? result.role : '')
          localStorage.setItem('type', result.type ? result.type : '')
          localStorage.setItem('photo', result.photo ? result.photo : '')
          localStorage.setItem('sex', result.sex ? result.sex : '')
          localStorage.setItem('agent', result.agent ? result.agent : '')
          localStorage.setItem('code', result.code ? result.code : '')
          localStorage.setItem('openid', result.openid ? result.openid : '')
          _this.setRole(result)


        })

      } else if (this.isInfo) {
        // 短信验证码登录
        this.$http.api.infoLogin({
          phone: this.phone,
          input: this.qrcode,
          code: this.addcode
        }).then(result => {
          // 处理登录成功后逻辑
          // console.log(result);

          _this.userInfo = result
          localStorage.setItem('user_id', result.user_id ? result.user_id : '')
          localStorage.setItem('name', result.name ? result.name : '')
          localStorage.setItem('phone', result.phone ? result.phone : '')
          localStorage.setItem('role_id', result.role_id ? result.role_id : '')
          localStorage.setItem('role', result.role ? result.role : '')
          localStorage.setItem('type', result.type ? result.type : '')
          localStorage.setItem('photo', result.photo ? result.photo : '')
          localStorage.setItem('sex', result.sex ? result.sex : '')
          localStorage.setItem('agent', result.agent ? result.agent : '')
          localStorage.setItem('code', result.code ? result.code : '')

          localStorage.setItem('openid', result.openid ? result.openid : '')
          _this.setRole(result)
          console.log('result6666:', result)

        })
      }

    },
    setRole(result) {
      let _this = this
      console.log('用户类型：', result.type)//用户类型： 1
      console.log('测试：', result.openid)//测试： null
      _this.disableds2 = true


      if (result.type == '1') {
// 为普通用户类型
        if (!result.openid) {
          _this.$http.api.getAppId({}).then(result => {
            _this.appid = result
          }).then(result => {

            if(this.oldUrl===null){
              _this.$router.push({ name: 'index' })
            }else{
              _this.$router.go(-1)
            }
          })
        } else {
          localStorage.setItem('openid', result.openid)
          if(this.oldUrl===null){
            _this.$router.push({ name: 'index' })
          }else{
            _this.$router.go(-1)
          }

        }
      } else if (_this.userInfo.type == '2') {
        // 业务员

        if (!result.openid) {
          _this.$http.api.getAppId({}).then(result => {
            _this.appid = result
          }).then(result => {
              _this.$router.push({ name: 'message', params: { type: 2 } })
            })
        } else {
          // 重定向到首页
          localStorage.setItem('openid', result.openid)
          _this.$router.push({ name: 'message', params: { type: 2 } })


          // const redirect = _this.$route.query.redirect
          // console.log('redirect:',redirect)
          // if (redirect) {
          //
          //   _this.$router.push(redirect)
          //   console.log('存在回跳地址就回跳')
          // } else {
          //
          //   _this.$router.push({ name: 'message', params: { type: 2 } })
          //   console.log('否则就跳到默认的首页')
          // }
          //

        }
      } else if (_this.userInfo.type == '3') {
        // 医生
        // if(result.user_id){

        if (!result.openid) {
          _this.$http.api.getAppId({}).then(result => {
            _this.appid = result
          }).then(result => {
              _this.$router.go(-1)

            })
        } else {
          localStorage.setItem('openid', result.openid)
          _this.$router.go(-1)

        }
      }

    },


    infoLogin() {
      this.btnText = this.btnText == '密码登录' ? '短信验证码登录' : '密码登录'
      this.isInfo = !this.isInfo
    }
  },

  components: {}
}
</script>
<style lang="less" scoped>
.login_container {
  width: 100%;
  // height: 100;
  background: url('../assets/images/j-p1.jpg') top center no-repeat;
  background-size: cover;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  text-align: center;
  overflow: hidden;

  .login_imgLogo {
    width: 100%;
    text-align: center;
    margin-top: 117px;
    margin-bottom: 45px;

    img {
      width: 131px;
      margin: 0 auto;
    }
  }

  .login_password {
    width: 240px;
    height: 100px;
    margin: 0 auto;
    text-align: center;
    border: 1px solid #b3daf2;
    border-radius: 5px;
    overflow: hidden;

    input {
      width: 240px;
      height: 50px;
      font-size: 14px;
      background: 0 0;
      border-bottom: 1px solid #b3daf2;
      color: #fff;
      padding-left: 10px;
    }

    ::-webkit-input-placeholder {
      color: rgba(255, 255, 255, .8)
    }

    ::-moz-placeholder {
      color: rgba(255, 255, 255, .8)
    }

    ::-ms-input-placeholder {
      color: rgba(255, 255, 255, .8)
    }

    input:nth-child(2) {
      border: none;
    }
  }

  .login_yzm {
    .login_yzm {
      width: 100%;
      // height: 50px;
      border-bottom: 1px solid #b3daf2;
      text-align: center;
      overflow: hidden;

      input {
        width: 65%;
        float: left;
        border: none;
      }

      button {
        width: 70px;
        // height: 30px;
        font-size: 8px;
        margin-top: 14px;
        margin-right: 5px;
        border: none;
        border-radius: 18px;
        background: #fff;
        line-height: 24px;
        outline: none;
        color: #61B0E3;
        float: right;
      }
    }
  }

  .login_p {
    width: 240px;
    height: 20px;
    margin: 20px auto 0;
    position: relative;

    .register {
      position: absolute;
      left: 2%;
      font-size: 14px;
      color: #fff;
    }

    .login_type {
      position: absolute;
      right: 2%;
      font-size: 14px;
      color: #fff;
    }
  }

  .login_submit {
    width: 241px;
    height: 38px;
    line-height: 38px;
    background: rgba(255, 255, 255, 1);
    border-radius: 19px;
    outline: none;
    border: none;
    color: #61B0E3;
    margin: 31px auto 0;
    font-size: 18px;
  }
}
</style>
